import SideDrawer from '../Common/SideDrawer/SideDrawer'
import { INVENTORY_DETAIL_FIELDS } from '../../common/constant/page-constant'
import './ManagePharmacyInventory.scss'

const ManagePharmacyInventoryForm = ({
  open,
  handleDrawerToggle,
  serverError,
  editItemData,
  handleItemDetailsUpdate,
  handleSubmit,
}) => {
  return (
    <SideDrawer
      handleDrawerToggle={handleDrawerToggle}
      open={open}
      drawerButton={true}
      drawerHeading="Edit Inventory Item"
      buttonText={'Save'}
      handleClick={() => handleSubmit()}
    >
      <div className="wizardFieldset">
        {serverError && <div className="invalidFeedback mb-4">{serverError}</div>}

        {editItemData?.invoice_number && (
          <div className="inventoryItemInfo mb-4">
            <div className="infoRow">
              <span className="infoLabel">Invoice No:</span>
              <span className="infoValue">{editItemData.invoice_number}</span>
            </div>
            <div className="infoRow">
              <span className="infoLabel">Pharmacy:</span>
              <span className="infoValue">{editItemData.pharmacy_name}</span>
            </div>
            <div className="infoRow">
              <span className="infoLabel">Product:</span>
              <span className="infoValue">{editItemData.product_name}</span>
            </div>
          </div>
        )}

        <div className="formGroup formFloating fgrow1">
          <input
            type="text"
            className="formControl"
            id="batchNumber"
            placeholder="Batch Number"
            value={editItemData?.[INVENTORY_DETAIL_FIELDS.BATCH_NUMBER] || ''}
            onChange={(e) =>
              handleItemDetailsUpdate(
                INVENTORY_DETAIL_FIELDS.BATCH_NUMBER,
                e.target.value
              )
            }
          />
          <label htmlFor="batchNumber">Batch Number</label>
        </div>

        <div className="formGroup formFloating fgrow1">
          <input
            type="date"
            className="formControl"
            id="expiryDate"
            placeholder="Expiry Date"
            value={editItemData?.[INVENTORY_DETAIL_FIELDS.EXPIRY_DATE] || ''}
            onChange={(e) =>
              handleItemDetailsUpdate(
                INVENTORY_DETAIL_FIELDS.EXPIRY_DATE,
                e.target.value
              )
            }
          />
          <label htmlFor="expiryDate">Expiry Date</label>
        </div>

        <div className="formGroup formFloating fgrow1">
          <input
            type="number"
            className="formControl"
            id="quantity"
            placeholder="Qty"
            value={editItemData?.[INVENTORY_DETAIL_FIELDS.QUANTITY] || ''}
            onChange={(e) =>
              handleItemDetailsUpdate(
                INVENTORY_DETAIL_FIELDS.QUANTITY,
                e.target.value
              )
            }
          />
          <label htmlFor="quantity">Qty</label>
        </div>

        <div className="formGroup formFloating fgrow1">
          <input
            type="number"
            className="formControl"
            id="bonusQuantity"
            placeholder="Bonus Qty"
            value={editItemData?.[INVENTORY_DETAIL_FIELDS.BONUS_QUANTITY] || ''}
            onChange={(e) =>
              handleItemDetailsUpdate(
                INVENTORY_DETAIL_FIELDS.BONUS_QUANTITY,
                e.target.value
              )
            }
          />
          <label htmlFor="bonusQuantity">Bonus Qty</label>
        </div>

        <div className="formGroup formFloating formInputText fgrow1">
          <div className="preInputGroup backColor">
            <div className="preInputText">BDT</div>
          </div>
          <input
            type="number"
            className="formControl"
            id="totalPrice"
            placeholder="Total Price"
            value={editItemData?.[INVENTORY_DETAIL_FIELDS.TOTAL_PRICE] || ''}
            onChange={(e) =>
              handleItemDetailsUpdate(
                INVENTORY_DETAIL_FIELDS.TOTAL_PRICE,
                e.target.value
              )
            }
          />
          <label htmlFor="totalPrice">Total Price</label>
        </div>

        <div className="formGroup formFloating formInputText fgrow1">
          <div className="preInputGroup backColor">
            <div className="preInputText">BDT</div>
          </div>
          <input
            type="number"
            className="formControl"
            id="ratePerUnit"
            placeholder="Rate/Unit"
            value={editItemData?.[INVENTORY_DETAIL_FIELDS.RATE_PER_UNIT] || ''}
            onChange={(e) =>
              handleItemDetailsUpdate(
                INVENTORY_DETAIL_FIELDS.RATE_PER_UNIT,
                e.target.value
              )
            }
          />
          <label htmlFor="ratePerUnit">Rate/Unit</label>
        </div>
      </div>
    </SideDrawer>
  )
}

export default ManagePharmacyInventoryForm
